import React, { Component } from 'react';
import { Grid, Row, Col, Table, ButtonToolbar, Button } from 'react-bootstrap';

import { MapPointForm } from './MapPointForm';
import { MapPointsCommand } from '../../commands/MapPointsCommand';
import { PhysicalStopsCommand } from '../../commands/PhysicalStopsCommand';
import { InterfacesCommand } from '../../../files/commands/InterfacesCommand';
import { LoadingSpinner } from '../../../LoadingSpinner';
import { TitleRow } from '../../../TitleRow';
import { SearchBar } from '../../../SearchBar';
import { TableButton } from '../../../TableButton';
import { HandleMessage } from '../../../HandleMessage';
import { HandleDialog } from '../../../HandleDialog';
import { PaginationBuilder } from '../../../PaginationBuilder';
import { PaginationHelper } from '../../../helpers/PaginationHelper';
import { SearchHelper } from '../../../helpers/SearchHelper';
import ColumnResize from "react-table-column-resizer";

export class TransportAuthorityMapPoints extends Component {
    constructor(props) {
        super(props);

        this.state = {
            commands: {
                mapPoints: new MapPointsCommand(),
                stops: new PhysicalStopsCommand(),
                interfaces: new InterfacesCommand(),
            },
            table: {
                data: [],
                page: 1,
                elementsPerPage: 50,
                filter: ""
            },
            dependencies: {
                stops: [],
                interfaces: []
            },
            form: {
                title: undefined,
                data: undefined,
                original: undefined
            },
            actions: {
                isLoadingMapPoints: true,
                isLoadingStops: true,
                isLoadingInterfaces: true,
                isUpdating: false,
                isDeleting: false
            },
            message: {
                show: false,
                message: undefined,
                style: undefined,
                icon: undefined,
                title: ""
            },
            dialog: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined,
                argument: undefined
            }
        };
    }

    componentDidMount() {
        this.getMapPoints();
        this.getInterfaces();
        this.getStops();
    }

    // ----------------------

    getMapPoints(resetData = false) {
        if (resetData) {
            const { table } = this.state;

            table.data = [];
            
            this.setState({
                table: table,
            });
        }
        
        const { commands, actions } = this.state;

        actions.isLoadingMapPoints = true;
        commands.mapPoints.getAllTransportAuthority(
            (a) => this.listSuccessCallback(a),
            (a) => this.listErrorCallback(a)
        );

        this.setState({
            actions: actions
        });
    }

    getInterfaces(resetData = false) {
        if (resetData) {
            const { actions, dependencies } = this.state;

            dependencies.interfaces = [];
            actions.isLoadingInterfaces = true;

            this.setState({
                dependencies: dependencies,
                actions: actions
            });
        }

        const { commands } = this.state;
        commands.interfaces.getAllTransportAuthority(
            (a) => this.listInterfacesSuccessCallback(a),
            (a) => this.listInterfacesErrorCallback(a)
        );
    }

    getStops(resetData = false) {
        if (resetData) {
            const { actions, dependencies } = this.state;

            dependencies.stops = [];
            actions.isLoadingStops = true;

            this.setState({
                dependencies: dependencies,
                actions: actions
            });
        }

        const { commands } = this.state;
        commands.stops.getAll(
            (a) => this.listStopsSuccessCallback(a),
            (a) => this.listStopsErrorCallback(a)
        );
    }

    // ---------------------------

    setErrorMessage(messageReceived) {
        const { message } = this.state;

        if (message.show) {
            messageReceived = `${message.message}\n${messageReceived}`;
        }

        this.setState({
            message: {
                show: true,
                message: messageReceived,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });
    }

    setSuccessMessage(messageReceived) {
        const { message } = this.state;
        const updatedMessage = Object.assign({}, message);

        if (message.show) {
            updatedMessage.message = `${message.message}\n${messageReceived}`;
        }

        this.setState({
            message: updatedMessage
        });
    }

    listSuccessCallback(result) {
        const { table, actions } = this.state;
        const totalPages = PaginationHelper.getTotalPages(result.length, table.elementsPerPage);

        actions.isLoadingMapPoints = false;
        table.data = result;
        if (0 !== totalPages) {
            table.page = table.page > totalPages ? totalPages : table.page;
        }
        else {
            table.page = 1;
        }

        // Update table
        this.setState({
            table: table,
            actions: actions
        });
    }

    listStopsSuccessCallback(result) {
        const { dependencies, actions } = this.state;

        actions.isLoadingStops = false;
        dependencies.stops = result;

        // Update table
        this.setState({
            dependencies: dependencies,
            actions: actions
        });
    }

    listInterfacesSuccessCallback(result) {
        const { dependencies, actions } = this.state;

        actions.isLoadingInterfaces = false;
        dependencies.interfaces = result;

        // Update table
        this.setState({
            dependencies: dependencies,
            actions: actions
        });
    }

    listErrorCallback(messageReceived) {
        const { table, actions } = this.state;

        actions.isLoadingMapPoints = false;
        table.data = [];
        table.page = 1;
        this.setErrorMessage(messageReceived);

        this.setState({
            table: table,
            actions: actions
        });
    }

    listStopsErrorCallback(messageReceived) {
        const { dependencies, actions } = this.state;

        actions.isLoadingStops = false;
        dependencies.stops = [];
        this.setErrorMessage(messageReceived);

        this.setState({
            dependencies: dependencies,
            actions: actions
        });
    }

    listInterfacesErrorCallback(messageReceived) {
        const { dependencies, actions } = this.state;

        actions.isLoadingInterfaces = false;
        dependencies.interfaces = [];
        this.setErrorMessage(messageReceived);

        this.setState({
            dependencies: dependencies,
            actions: actions
        });
    }

    operationSuccessCallback(messageReceived, updateAction) {
        const { actions } = this.state;

        actions[updateAction] = false;
        this.setSuccessMessage(messageReceived);

        this.setState({
            actions: actions
        });

        this.getMapPoints();
        this.getStops(true);
    }

    operationErrorCallback(messageReceived, updateAction) {
        const { actions } = this.state;

        actions[updateAction] = false;
        this.setErrorMessage(messageReceived);

        this.setState({
            actions: actions
        });
    }

    // ---------------------------

    onCreateClick() {
        const { form } = this.state;

        form.original = null;
        form.data = {
            id: 0,
            name: "",
            latitude: "",
            longitude: "",
            addInfo: "",
            stops: []
        };
        form.title = "Criar";

        this.setState({
            form: form
        });
    }

    onEditClick(data) {
        const { form } = this.state;

        form.original = data;
        form.data = Object.assign({}, data);
        form.title = "Editar";

        this.setState({
            form: form
        });
    }

    onDeleteClick(data) {
        this.setState({
            dialog: {
                show: true,
                title: "Aviso",
                message: `Tem a certeza que pretende eliminar o ponto notável "${data.name}"`,
                style: "warning",
                icon: "alert",
                argument: {
                    id: data.id
                }
            }
        });
    }

    onMapPointSave(mapPoint) {
        const { commands, actions } = this.state;
        commands.mapPoints.saveTransportAuthority(
            mapPoint,
            (a) => this.operationSuccessCallback(a, "isUpdating"),
            (a) => this.operationErrorCallback(a, "isUpdating")
        );

        actions.isUpdating = true;
        this.setState({
            actions: actions
        });

        this.onMapPointFormExit();
    }

    onMapPointFormExit() {
        this.setState({
            form: {
                title: undefined,
                data: undefined,
                original: undefined,
            }
        });
    }

    onExitMessage() {
        this.setState({
            message: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined
            }
        });
    }

    onExitDialog(isToExecute, argument) {
        const { actions } = this.state;

        if (isToExecute) {
            const { commands } = this.state;
            commands.mapPoints.deleteTransportAuthority(
                argument.id,
                (a) => this.operationSuccessCallback(a, "isDeleting"),
                (a) => this.operationErrorCallback(a, "isDeleting")
            );

            actions.isDeleting = true;
        }

        this.setState({
            actions: actions,
            dialog: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined,
                argument: undefined
            }
        });
    }

    // ---------------------------

    onChangePage(page) {
        const { table } = this.state;

        table.page = page;

        this.setState({
            table: table
        });
    }

    onChangeElementsPerPage(elements) {
        const { table } = this.state;

        table.elementsPerPage = elements;

        this.setState({
            table: table
        });
    }

    onSearch(filter) {
        const { table } = this.state;

        table.filter = filter;

        this.setState({
            table: table
        });
    }

    // -------------------

    compareStopsLength(stops) {
        return stops.length;
    }

    // -------------------

    renderForm() {
        const { form, dependencies } = this.state;

        if (null === form.data || undefined === form.data) {
            return null;
        }

        return (
            <MapPointForm title={form.title}
                mapPoint={form.data}
                stops={dependencies.stops.concat(form.data.stops)}
                interfaces={dependencies.interfaces}
                onSave={(a) => this.onMapPointSave(a)}
                onHide={() => this.onMapPointFormExit()} />
        );
    }

    renderStopsLength(data) {
        if (undefined === data.stops) {
            return '0';
        }

        return data.stops.length;
    }

    renderLoading(isLoading) {
        if(isLoading) {
            return (
                <LoadingSpinner />
            );
        }

        return null;
    }

    renderTable(isWaiting) {
        const { table } = this.state;

        const dataFiltered = SearchHelper.search({
            filter: table.filter,
            data: table.data,
            fields: ["name", "addInfo", "stops"],
            callbackComparison: [{ "stops": (a) => this.compareStopsLength(a) }]
        });
        const totalPages = PaginationHelper.getTotalPages(dataFiltered.length, table.elementsPerPage);
        const activePage = totalPages < table.page ? totalPages : table.page;
        const partialData = dataFiltered.slice((activePage - 1) * table.elementsPerPage, activePage * table.elementsPerPage);

        return (
            <Grid fluid>
                <Row>
                    <Col sm={12}>
                        <div className="table-loading">
                            <Table responsive striped hover>
                                <thead>
                                    <tr>
                                        <th>Nome</th>
                                        <ColumnResize className="columnResizer" />
                                        <th>Latitude</th>
                                        <ColumnResize className="columnResizer" />
                                        <th>Longitude</th>
                                        <ColumnResize className="columnResizer" />
                                        <th>Informação Adicional</th>
                                        <ColumnResize className="columnResizer" />
                                        <th>Paragens Associadas</th>
                                        <ColumnResize className="columnResizer" />
                                        <th>&nbsp;</th>
                                    </tr>
                                </thead>
                                <tbody className={isWaiting ? "overlay" : ""}>
                                    {
                                        partialData.map((data, idx) =>
                                            <tr key={`map-point-${idx}`}>
                                                <td>{data.name}</td>
                                                <td className="column_resizer_body" />
                                                <td>{data.latitude}</td>
                                                <td className="column_resizer_body" />
                                                <td>{data.longitude}</td>
                                                <td className="column_resizer_body" />
                                                <td>{data.addInfo}</td>
                                                <td className="column_resizer_body" />
                                                <td>{this.renderStopsLength(data)}</td>
                                                <td className="column_resizer_body" />
                                                <td>
                                                    <ButtonToolbar className="pull-right">
                                                        <TableButton marginRight icon="icon-edit" title="Editar" onClick={() => this.onEditClick(data)} />
                                                        <TableButton icon="icon-trash" title="Eliminar" onClick={() => this.onDeleteClick(data)} />
                                                    </ButtonToolbar>
                                                </td>
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </Table>

                            <PaginationBuilder
                                currentPage={activePage}
                                elementsPerPage={table.elementsPerPage}
                                dataLength={dataFiltered.length}
                                onChangePage={(a) => this.onChangePage(a)}
                                onChangeElementsPerPage={(a) => this.onChangeElementsPerPage(a)} />

                                {this.renderLoading(isWaiting)}
                        </div>
                    </Col>
                </Row>
            </Grid>
        );
    }

    render() {
        const { actions, message, dialog } = this.state;
        const { title } = this.props;

        return (
            <div>
                <TitleRow title={title} showSeparator={true}>
                    <Col className="padding-0" xs={2} sm={1} md={4}>
                        <ButtonToolbar className="pull-right title-row-col-btns">
                            <Button onClick={() => this.onCreateClick()}>CRIAR</Button>
                        </ButtonToolbar>
                    </Col>
                    <Col className="padding-0" xs={10} sm={11} md={8}>
                        <div className="search-bar">
                            <SearchBar onSearch={(a) => this.onSearch(a)} />
                        </div>
                    </Col>
                </TitleRow>

                {this.renderTable(actions.isLoadingMapPoints || actions.isLoadingStops || actions.isLoadingInterfaces || actions.isUpdating || actions.isDeleting)}
                {this.renderForm()}

                <HandleMessage
                    title={message.title}
                    message={message.message}
                    style={message.style}
                    icon={message.icon}
                    show={message.show}
                    onHide={() => this.onExitMessage()} />

                <HandleDialog
                    show={dialog.show}
                    title={dialog.title}
                    message={dialog.message}
                    style={dialog.style}
                    icon={dialog.icon}
                    argument={dialog.argument}
                    onExit={(a, b) => this.onExitDialog(a, b)} />
            </div>
        );
    }
}
